import axios from 'axios';
import { Env } from '@/configuration';
import { Settings, LeagueTableViewItem, NextMatchWidgetModel, LastMatchWidgetModel } from './models';
import { MatchResultModel } from '../models/MatchResultModel';


const fetchLeagueSettings = async () => {
  const settingsUrl = Env.AdminApiOptions.endpointUrl('league/settings');
  const response = await axios.get(settingsUrl);
  const result: Settings = response && response.data;
  return result;
};

const fetchLeagueTable = async (seasonId?: number): Promise<LeagueTableViewItem[]> => {
  const apiUri = Env.LeagueApiOptions.endpointUrl(seasonId ? `leagueTable/${seasonId}` :  'leagueTable');
  const response = await axios.get(apiUri);
  const result: LeagueTableViewItem[] = response && response.data;
  return result;
};

const fetchNextMatchWidget = async (seasonId: number, teamId?: number): Promise<NextMatchWidgetModel> => {
  const teamIdUrlChunk = teamId ? `/${teamId}` : '';
  const apiUri = Env.LeagueApiOptions.endpointUrl(`matches/${seasonId}/nextMatchWidget${teamIdUrlChunk}`);
  const response = await axios.get(apiUri);
  const result: NextMatchWidgetModel = response && response.data;
  return result;
};

const fetchLastMatchWidget = async (seasonId: number, teamId?: number): Promise<LastMatchWidgetModel> => {
  const teamIdUrlChunk = teamId ? `/${teamId}` : '';
  const apiUri = Env.LeagueApiOptions.endpointUrl(`matches/${seasonId}/lastMatchWidget${teamIdUrlChunk}`);
  const response = await axios.get(apiUri);
  const result: LastMatchWidgetModel = response && response.data;
  return result;
};

const fetchLastMatchDayResultsWidget = async (seasonId: number): Promise<MatchResultModel[]> => {
  const apiUri = Env.LeagueApiOptions.endpointUrl(`matches/${seasonId}/lastMatchDayResultsWidget`);
  const response = await axios.get(apiUri);
  const result: MatchResultModel[] = response && response.data;
  return result;
};

export default {
  fetchLeagueSettings,
  fetchLeagueTable,
  fetchNextMatchWidget,
  fetchLastMatchWidget,
  fetchLastMatchDayResultsWidget,
};
